import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../../mapanalysis/chartTemplate";
import * as d3 from "d3";
import { Wrapper } from "../../helper/warpLabels";
import { Remove_empty_bins } from "../../helper/remove_empty_bins";
const landChartFunc = (divRef, ndx) => {
  const land_area = ndx.dimension(
    (d) => d.household_Land_Area_farming_categories
  );
  const land_area_grp = land_area.group().reduceSum((d) => d.land_Area_Ha);
    var f = d3.format(",.0f")
  const landsizeChart = dc.barChart(divRef);

  landsizeChart
    .width(200)
    .height(180)
    .x(d3.scaleBand())
    .margins({ left: 2, top: 0, right: 0, bottom: 20 })
    .xUnits(dc.units.ordinal)
    .elasticY(true)
    .colorAccessor((d) => d.key)
    .ordinalColors(["#B5870D", "#8AB3C9", "#327E73"])
    //.colors(d3.scaleOrdinal().range(["#F5E9C8", "#8AB3C9", "#327E73"]))
    // .elasticX(true)
    .brushOn(false)
    .dimension(land_area)
    .barPadding(0.1)
    .outerPadding(0.05)
      .transitionDuration(1500)
      .valueAccessor((d) => {
          if (d.value == 0) {
              return d.value
          } else {
              return Math.log10(d.value)
          }

      })
      .title((d) => {
          if (d.key == "Commercial Farming") {
              return "Commercial Farming : " + f(d.value)
          } else if (d.key == "Inactive Farming") {
              return "Inactive Farming : " + f(d.value)
          } else {
              return "Subsistence Farming : " + f(d.value)
          }
      })
        .group(Remove_empty_bins(land_area_grp, null));

  landsizeChart.on("renderlet", function (d) {
    landsizeChart.selectAll("g.x.axis .tick text").call(Wrapper, 1); // call the wrapper function
  });
  landsizeChart.yAxis().ticks(0);

  return landsizeChart;
};

export const LandAreaHa = (props) => (
  <ChartTemplate chartFunction={landChartFunc} 
  title ="Land Area (Ha)"
  />
);
